export const QUERY_STRING_KEY_BLOCK_LIST = ['page'];
